import type { DocumentId } from '../types';
import type { BaseEntity } from '../base';

export const normalizeSelectedIds = (doc: BaseEntity, ids?: DocumentId[]) => {
  if (ids && ids.includes(doc._id)) {
    return ids;
  }

  return [doc._id];
};
